import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarraNavegacionyMenuLateral } from "./BarraNavegacionyMenuLateral";
import { Form, Segment } from "semantic-ui-react";
import { estiloSegmento } from "../../../estilos/segmentos";
import {
  inicio,
  hola,
  permitir_notificaciones,
  cambio_de_estado_de_viaje,
  TraducirEstado,
} from "../../../utils/traductor";
import { ENTORNO, HabilitarFireBase } from "../../../utils/constantes";
import {
  getrole,
  getusuarioPerfil,
  getid,
  getNombre,
  getEstadoConductor,
  setPermitirNotificaciones,
  getPermitirNotificaciones,
} from "../../../utils/variablesLocales";
import { EstadoViajeEnInicio } from "../../../componentes/NuevoViaje";
import { apiSubastador } from "../../../api/subastador";
import { apiViaje } from "../../../api/viaje";
import { apiUsuario } from "../../../api/usuario";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";
import { Alert } from "@mui/material";

const app = initializeApp(ENTORNO.firebaseConfig);
export const messaging = getMessaging(app);

const apiusuario = new apiUsuario();
const apisubastador = new apiSubastador();
const apiviaje = new apiViaje();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function Inicio({ props }) {
  const [Saldo, setSaldo] = useState(null);
  const [EstadoId, setEstadoId] = useState("0");
  const [Estado, setEstado] = useState(null);
  const [ViajeId, setViajeId] = useState(null);
  const [Partida, setPartida] = useState(null);
  const [Destino, setDestino] = useState(null);
  const [VerEnGoogleMaps, setVerEnGoogleMaps] = useState(null);
  const [ChoferId, setChoferId] = useState(null);
  const [Pasajero, setPasajero] = useState(null);
  const [Kms, setKms] = useState(null);
  const [Min, setMin] = useState(null);
  const [Precio, setPrecio] = useState(null);
  const [PartidaLatitud, setPartidaLatitud] = useState(null);
  const [PartidaLongitud, setPartidaLongitud] = useState(null);
  const [Conductor, setConductor] = useState(null);
  const [Marca, setMarca] = useState(null);
  const [Modelo, setModelo] = useState(null);
  const [Color, setColor] = useState(null);
  const [Dominio, setDominio] = useState(null);
  const [PartidaLocalidad, setPartidaLocalidad] = useState(null);
  const [PartidaProvincia, setPartidaProvincia] = useState(null);
  const [
    VerEnGoogleMapsRutaBusquedaPasajero,
    setVerEnGoogleMapsRutaBusquedaPasajero,
  ] = useState(null);
  const [MinLlegadaABuscarPasajero, setMinLlegadaABuscarPasajero] =
    useState(null);
  const [DestinoLatitud, setDestinoLatitud] = useState(null);
  const [DestinoLongitud, setDestinoLongitud] = useState(null);

  const [Permisos, setPermisos] = useState("");
  const [TokenUsuario, setTokenUsuario] = useState("");
  const [NotificacionUsuarioTitulo, setNotificacionUsuarioTitulo] =
    useState("");
  const [NotificacionUsuarioDescripcion, setNotificacionUsuarioDescripcion] =
    useState("");
  const [Error, setError] = useState("");

  const [Mensaje, setMensaje] = useState("");

  //////////////////////////////////////////////
  //DETECTAR PRIMER PLANO
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      actualizarEstado();
    } else {
    }
  });
  //////////////////////////////////////////////

  /////////////////////////
  //notificaciones
  const [open, setOpen] = React.useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [NotificacionUsuario, setNotificacionUsuario] = useState("");

  const permitirNotificaciones = async () => {
    try {
      obtenerTokenFirebase();
    } catch (error) {
      console.log(error);
    }
  };

  const obtenerTokenFirebase = async () => {
    try {
      if (HabilitarFireBase) {
        //preguntar si quiere recibir notificaciones
        const permission = await Notification.requestPermission();
        setPermisos(permission);

        if (permission === "granted") {
          setPermitirNotificaciones(true);

          //obtener token
          let token = "";
          token = await getToken(messaging, {
            vapidKey: ENTORNO.vapidKey,
          }).catch((error) => setError(error));

          if (token) {
            setTokenUsuario(token);
            apiusuario.actualizarTokenNotificacion(token);
          } else {
            setTokenUsuario("");
          }
        } else {
          setPermitirNotificaciones(false);
        }
      }
    } catch (error) {
      setError(error);
    }
  };
  /////////////////////////

  useEffect(() => {
    (async () => {
      if (HabilitarFireBase) {
        //activar escucha de notificaciones
        setError("Activando notificaciones desde useEffect");
        onMessage(messaging, (message) => {
          //actualizar token (esto lo hago porque iOS lo necesita)
          obtenerTokenFirebase();

          setNotificacionUsuario(message.notification.title);

          //cuando llega una notificacion, actualiza el estado
          actualizarEstado();

          //mostrar notificacion
          setMensaje(
            // TraducirEstado(cambio_de_estado_de_viaje) +
            //   ". " +
            message.notification.title
          );
          //mostrar mensaje de cambio de estado
          setOpen(true);
        });
      }
    })();
  }, []);

  ///////////////////////////

  useEffect(() => {
    (async () => {
      actualizarEstado();
    })();
  }, []);

  ///////////////////////////

  const actualizarEstado = async () => {
    try {
      //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
      if (getrole() !== "Conductor") {
        navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
      } else {
        //obtener ultimo viaje Activo: 1 (todos los Valorado=1, menos los FINALIZADO, CANCELADO)
        const respuesta = await apisubastador.obtenerConductor();

        if (respuesta.length > 0) {
          setEstadoId("0");
          setEstado(respuesta[0].Viaje_Estado);
          setViajeId(respuesta[0].Viaje_IdViaje);
          setPartida(respuesta[0].Viaje_Partida);
          setDestino(respuesta[0].Viaje_Destino);
          setVerEnGoogleMaps(respuesta[0].Viaje_VerEnGoogleMaps);
          setChoferId(getid());
          setPasajero(respuesta[0].Viaje_Pasajero);
          setKms(respuesta[0].Viaje_Kms);
          setMin(respuesta[0].Viaje_Min);
          setPrecio(respuesta[0].Viaje_PrecioSugerido);
          setPartidaLatitud(respuesta[0].Viaje_PartidaLatitud);
          setPartidaLongitud(respuesta[0].Viaje_PartidaLongitud);
          setConductor(
            respuesta[0].Viaje_Nombre + " " + respuesta[0].Viaje_Apellido
          );
          setMarca(respuesta[0].Vehiculo_Marca);
          setModelo(respuesta[0].Vehiculo_Modelo);
          setColor(respuesta[0].Vehiculo_Color);
          setDominio(respuesta[0].Vehiculo_Dominio);
          setPartidaLocalidad(respuesta[0].Viaje_PartidaLocalidad);
          setPartidaProvincia(respuesta[0].Viaje_PartidaProvincia);
          setVerEnGoogleMapsRutaBusquedaPasajero(
            respuesta[0].Viaje_VerEnGoogleMapsRutaBusquedaPasajero
          );
          setMinLlegadaABuscarPasajero(
            respuesta[0].Viaje_MinLlegadaABuscarPasajero
          );
          setDestinoLatitud(respuesta[0].Viaje_DestinoLatitud);
          setDestinoLongitud(respuesta[0].Viaje_DestinoLongitud);
          setSaldo(respuesta[0].Viaje_Saldo);

          if (respuesta[0].Viaje_Estado === "PENDIENTE DE ACEPTAR VIAJE") {
            setEstadoId("2");
          } else {
            if (respuesta[0].Viaje_Estado === "CONDUCTOR ASIGNADO") {
              setEstadoId("3");
            } else {
              if (respuesta[0].Viaje_Estado === "RUTA DE VIAJE ACTIVADA") {
                setEstadoId("4");
              } else {
                if (respuesta[0].Viaje_Estado === "TRANSITO ACTIVADO") {
                  setEstadoId("5");
                }
              }
            }
          }
        } else {
          setEstadoId("0");
          setEstado("");
          setViajeId("");
          setPartida("");
          setDestino("");
          setVerEnGoogleMaps("");
          setChoferId("");
          setPasajero("");
          setKms("");
          setMin("");
          setPrecio(0);
          setPartidaLatitud("");
          setPartidaLongitud("");
          setConductor("");
          setMarca("");
          setModelo("");
          setColor("");
          setDominio("");
          setPartidaLocalidad("");
          setPartidaProvincia("");
          setVerEnGoogleMapsRutaBusquedaPasajero("");
          setMinLlegadaABuscarPasajero("");
          setDestinoLatitud("");
          setDestinoLongitud("");
          setSaldo("");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const navigate = useNavigate();

  const EditarPerfil = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Conductor/EditarPerfil");
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <React.Fragment>
        <CssBaseline />
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              <img
                src={logoLocalPoint}
                style={{ marginTop: "8px" }}
                width="90"
                alt="Logo"
              />
            </Typography>
            <IconButton
              size="large"
              onClick={EditarPerfil}
              edge="end"
              color="inherit"
            >
              <AccountCircleIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Toolbar id="back-to-top-anchor" />
        <Container>
          <Box sx={{ my: 0 }}>
            <Segment style={estiloSegmento.Pasajero}>
              <Form>
                <div style={{ textAlign: "center" }}>
                  <h2>
                    {hola} {getNombre()}
                  </h2>

                  <Button onClick={permitirNotificaciones}>
                    {permitir_notificaciones}
                  </Button>
                </div>

                <EstadoViajeEnInicio
                  EstadoId={EstadoId}
                  Perfil={getusuarioPerfil()}
                  ViajeId={ViajeId}
                  Partida={Partida}
                  Destino={Destino}
                  VerEnGoogleMaps={VerEnGoogleMaps}
                  ChoferId={ChoferId}
                  Pasajero={Pasajero}
                  Kms={Kms}
                  Min={Min}
                  Precio={Precio}
                  PartidaLatitud={PartidaLatitud}
                  PartidaLongitud={PartidaLongitud}
                  Conductor={Conductor}
                  Marca={Marca}
                  Modelo={Modelo}
                  Color={Color}
                  Dominio={Dominio}
                  PartidaLocalidad={PartidaLocalidad}
                  PartidaProvincia={PartidaProvincia}
                  VerEnGoogleMapsRutaBusquedaPasajero={
                    VerEnGoogleMapsRutaBusquedaPasajero
                  }
                  MinLlegadaABuscarPasajero0={MinLlegadaABuscarPasajero}
                  DestinoLatitud={DestinoLatitud}
                  DestinoLongitud={DestinoLongitud}
                  Saldo={Saldo}
                ></EstadoViajeEnInicio>
              </Form>
            </Segment>
          </Box>
        </Container>
        <ScrollTop {...props}>
          <Fab size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
        <BarraNavegacionyMenuLateral />
      </React.Fragment>

      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          icon={<InfoOutlinedIcon fontSize="inherit" />}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {Mensaje}
        </Alert>
      </Snackbar>
    </div>
  );
}
